import { useCallback, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../store';
import { AppDispatch } from '../../store';
import { fetchWorkingHours } from '../../store/slices/workingHoursSlice';

export const useWorkingHours = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { orgWorkingHours, settingsOrgWorkingHours, isLoading, error } = useSelector(
    (state: RootState) => state.workingHours
  );
  const initialFetchDone = useRef(false);

  const selectedOrganizationId = useSelector(
    (state: RootState) => state.organizationContext.selectedOrganizationId
  );

  const fetchData = useCallback(async () => {
    if (!selectedOrganizationId) return;

    await dispatch(fetchWorkingHours({ organizationId: selectedOrganizationId }));
  }, [dispatch, selectedOrganizationId]);

  useEffect(() => {
    if (!initialFetchDone.current || selectedOrganizationId) fetchData();
    initialFetchDone.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => {
      initialFetchDone.current = false;
    };
  }, [selectedOrganizationId]);

  const refetch = useCallback(() => {
    if (selectedOrganizationId) {
      return dispatch(fetchWorkingHours({ organizationId: selectedOrganizationId }));
    }
  }, [dispatch, selectedOrganizationId]);
  return {
    orgWorkingHours,
    settingsOrgWorkingHours,
    isLoading,
    error,
    refetch,
  };
};
